"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageTabPaneReducer = void 0;

var _pageTabPaneActions = require("./page-tab-pane-actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Reducer for Page Tabs example page
var pageTabPaneReducer = function pageTabPaneReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = action.type;

  var _ref = action.payload || {},
      pageId = _ref.pageId,
      tabId = _ref.tabId;

  switch (type) {
    case _pageTabPaneActions.PAGE_TAB_PANE_CHANGE:
      {
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, pageId, tabId));
      }

    default:
      return state;
  }
};

exports.pageTabPaneReducer = pageTabPaneReducer;
//# sourceMappingURL=page-tab-pane-reducer.js.map